module.exports = __webpack_public_path__ + "static/img/plansza-80px.10a4f7c5.png";